import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../services/visitorService';
import { regionFromPathname } from '../../utils/regionFromPath';
import { REGION_HREFLANG } from '../../config/publicRegions';

function inferPageMeta(pathname) {
  const parts = String(pathname || '').split('/').filter(Boolean);
  const region = regionFromPathname(pathname);
  const offset = region ? 1 : 0;
  const seg = parts[offset] || '';
  const idPart = parts[offset + 2] || parts[offset + 1] || '';
  const idMatch = String(idPart).match(/^(\d+)/);
  const tmdbId = idMatch ? parseInt(idMatch[1], 10) : null;
  const isSimilar = parts.includes('similar');
  const categoryMap = {
    movies: 'movie',
    tv: 'tv',
  };
  if (seg === 'anime' && parts[offset + 1] === 'movies') return { pageType: isSimilar ? 'media-similar' : 'media-detail', category: 'anime_movie', tmdbId };
  if (seg === 'anime' && parts[offset + 1] === 'tv') return { pageType: isSimilar ? 'media-similar' : 'media-detail', category: 'anime_tv', tmdbId };
  if (categoryMap[seg]) return { pageType: isSimilar ? 'media-similar' : 'media-detail', category: categoryMap[seg], tmdbId };
  if (seg === 'search') return { pageType: 'search', category: '', tmdbId: null };
  if (seg === 'categories') return { pageType: 'categories', category: '', tmdbId: null };
  if (seg === 'similar') return { pageType: 'similar-browse', category: '', tmdbId: null };
  return { pageType: seg || 'home', category: '', tmdbId: null };
}

export default function VisitorTracking() {
  const location = useLocation();
  const lastPathRef = useRef('');

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    if (!path || path === lastPathRef.current) return;
    lastPathRef.current = path;

    const region = regionFromPathname(location.pathname);
    const language = REGION_HREFLANG[region] || 'en-US';
    const meta = inferPageMeta(location.pathname);

    trackPageView({
      path,
      pageType: meta.pageType,
      category: meta.category,
      tmdbId: meta.tmdbId,
      language,
    });
  }, [location]);

  return null;
}
